import React, {useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import { getSellRequestById } from "../../api/web";
import moment from "moment";

const SellRequestDetail = (props) => {

    const id = props.match.params.id;
    const [initialLoading, setInitialLoading] = useState(true);
    const [request, setRequest] = useState(null);

    useEffect(() => {
        getSellRequestById(id).then((response) => {
            if (!response.error) {
                setRequest(response.payload);
            }
            setInitialLoading(false);
        });
    }, [id]);

    const statusBadge = (status) => {
        const map = {
            PENDING: { cls: 'bg-warning text-dark', style: {} },
            ACCEPTED: { cls: 'bg-success text-white', style: {} },
            REJECTED: { cls: 'bg-danger text-white', style: {} },
            FLAGGED: { cls: 'bg-info text-white', style: {} }
        };
        const c = map[status] || { cls: 'bg-secondary text-white', style: {} };
        return <span className={`badge ${c.cls}`} style={c.style}>{status || '—'}</span>;
    };

    const personDisplay = (obj) => {
        if (!obj) return '—';
        if (typeof obj === 'object') {
            const n = [obj.first_name, obj.last_name].filter(Boolean).join(' ');
            return n || obj.username || obj.id || '—';
        }
        return `#${obj}`;
    };

    if (initialLoading) {
        return (
            <div className="content-body">
                <div className="container d-flex justify-content-center ht-100p">
                    <div className="d-flex flex-column align-items-center justify-content-center">
                        <div className="spinner-border" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                        <p className="mg-t-10">Loading sell request</p>
                    </div>
                </div>
            </div>
        );
    }

    if (!request) {
        return (
            <div className="content-body">
                <div className="container pd-x-0">
                    <div className="mg-b-20">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item"><Link to="/dashboard">Menu</Link></li>
                                <li className="breadcrumb-item"><Link to="/sell_request">Sell Requests</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Not found</li>
                            </ol>
                        </nav>
                        <p className="tx-danger">Sell request not found.</p>
                        <Link to="/sell_request" className="btn btn-sm btn-primary">Back to Sell Requests</Link>
                    </div>
                </div>
            </div>
        );
    }

    const to = request.trade_offer;
    const tradeOfferLabel = to
        ? `${to.aggregator?.name ?? to.aggregator?.pacra_id ?? '—'} · ${to.crop?.name ?? '—'} · ${to.town?.name ?? '—'}`
        : '—';
    const productName = request.product?.name ?? (request.product?.crop?.name) ?? '—';

    return (
        <div className="content-body">
            <div className="container pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item"><Link to="/dashboard">Menu</Link></li>
                                <li className="breadcrumb-item"><Link to="/sell_request">Sell Requests</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Request #{request.id}</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-5 tx-spacing--1">Sell Request #{request.id}</h4>
                        <div className="d-flex flex-wrap align-items-center gap-2">
                            <span className="tx-color-03 tx-13">{personDisplay(request.user)} · {productName}</span>
                            {statusBadge(request.status)}
                        </div>
                    </div>
                    <div className="d-none d-md-block">
                        <Link to="/sell_request" className="btn btn-sm pd-x-15 btn-secondary btn-uppercase">
                            <i className="wd-10 mg-r-5 fa fa-arrow-left"></i> Back to list
                        </Link>
                    </div>
                </div>

                <div className="row row-xs">
                    <div className="col-md-12 mg-t-10">
                        <div className="nav-wrapper mg-b-20 tx-13">
                            <ul className="nav nav-line nav-fill tx-medium">
                                <li className="nav-item">
                                    <a href="#info" className="nav-link active" data-bs-toggle="tab">
                                        <i className="ion-md-information-circle"/> Information
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div className="tab-content">
                            <div id="info" className="tab-pane fade active show">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row row-sm">
                                            <div className="col-md-6">
                                                <p><strong>User:</strong> {personDisplay(request.user)}</p>
                                                <p><strong>Trade Offer:</strong>{' '}
                                                    {to?.id != null ? (
                                                        <Link to={`/trade_offer/${to.id}`}>#{to.id} · {tradeOfferLabel}</Link>
                                                    ) : (
                                                        tradeOfferLabel
                                                    )}
                                                </p>
                                                <p><strong>Product:</strong> {productName}</p>
                                                <p><strong>Quantity:</strong> {request.quantity != null ? Number(request.quantity).toLocaleString() : '—'} {request.units ?? 'kg'}</p>
                                                <p><strong>Suggested price:</strong> {request.suggested_price != null ? Number(request.suggested_price).toLocaleString() : '—'}</p>
                                                <p><strong>Status:</strong> {statusBadge(request.status)}</p>
                                            </div>
                                            <div className="col-md-6">
                                                <p><strong>Date created:</strong> {request.date_created ? moment(request.date_created).format("Do MMM, YYYY HH:mm") : '—'}</p>
                                                <p><strong>Date modified:</strong> {request.date_modified ? moment(request.date_modified).format("Do MMM, YYYY HH:mm") : '—'}</p>
                                                {request.notes ? (
                                                    <p><strong>Notes:</strong><br/><span className="tx-color-03">{request.notes}</span></p>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SellRequestDetail;
